(function () {
    'use strict';
    angular.module('doclr.appconfig',[])
        .service('AppConfigService', AppConfigService);
})();